export type TNavigation = {
  name: string;
  url: string;
  links: {
    title?: {
      text: string;
      url: string;
    };
    urls: {
      text: string;
      url: string;
    }[];
  }[];
};

export type TNavigationState = {
  value?: ENavigation;
};

export enum ENavigation {
  SecondaryMarket = 'secondaryMarket',
  FirstMarket = 'firstMarket',
  AdPlacement = 'adPlacement',
  PaidServices = 'paidServices',
  BenefitsCpt = 'benefitsCpt',
  ClientsDirection = 'clientsDirection',
  LeadGeneration = 'leadGeneration',
  MediaAd = 'mediaAd',
  ServiceFeatures = 'serviceFeatures',
  OtaModel = 'otaModel',
  AdvantagesDaily = 'advantagesDaily',
  FinPlatform = 'finPlatform',
  OnlineContract = 'onlineContract',
  SmartDeal = 'smartDeal',
  ElReg = 'elReg',
  AiInSearch = 'aiInSearch',
  ServicesOwners = 'servicesOnwers',
  ServicesBuyers = 'servicesBuyers',
  DatabaseModeration = 'databaseModeration',
  ForDevelopers = 'forDevelopers',
  Cybersecurity = 'cybersecurity',
}
